namespace RedBullMOBILE360.BulkSMS {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.BulkSMS.BulkSMSDialog')
    export class BulkSMSDialog extends Serenity.EntityDialog<BulkSMSRow, any> {
        protected getFormKey() { return BulkSMSForm.formKey; }
        protected getIdProperty() { return BulkSMSRow.idProperty; }
        protected getLocalTextPrefix() { return BulkSMSRow.localTextPrefix; }
        protected getNameProperty() { return BulkSMSRow.nameProperty; }
        protected getService() { return BulkSMSService.baseUrl; }
        protected getDeletePermission() { return BulkSMSRow.deletePermission; }
        protected getInsertPermission() { return BulkSMSRow.insertPermission; }
        protected getUpdatePermission() { return BulkSMSRow.updatePermission; }

        protected form = new BulkSMSForm(this.idPrefix);
    }
}